import React, { FC } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  ILibDropdownItem,
  LanguageSelector
} from '@infologistics/frontend-libraries'

import { setLanguage } from '@store/modules/utils/actions'

import { BrowserStorage, Instance, LanguageNamesShort, Languages, LanguagesNames, lookupLocalStorage } from '@const/consts'
import { getPreferredLanguages } from '@utils/utils'
import { ILanguageSelectorProps as IProps } from './types'
import { IApplicationState } from '@store/types/commonTypes'

const LanguageSelectorWrapper: FC<IProps> = ({ i18n: { language, changeLanguage }, isThemeMini }) => {
  const dispatch = useDispatch<any>()
  const instanceFromStore = useSelector((state: IApplicationState) => state.utils.instance)
  const instance = localStorage.getItem(BrowserStorage.INSTANCE) ?? instanceFromStore ?? Instance.GLOBAL
  const languageFinal = instance !== Instance.RUSSIAN && language === Languages.RU  ? Languages.EN : language;

  const handleChangeLanguage = ({ name }: ILibDropdownItem): any =>
    changeLanguage(name).then(() => {
      window.localStorage.setItem(lookupLocalStorage, name)
      dispatch(setLanguage(name))
    })

  return (
    <LanguageSelector
      isThemeMini={isThemeMini}
      language={languageFinal}
      languageNames={LanguagesNames}
      languageNamesShort={LanguageNamesShort}
      languages={getPreferredLanguages(instance)}
      onLanguageChange={handleChangeLanguage}
    />
  )
}

export default withTranslation('language')(LanguageSelectorWrapper)
